import React from 'react';
import { render } from 'react-dom';
import { App } from '@inertiajs/inertia-react';
import { InertiaProgress } from '@inertiajs/progress';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';

require('./bootstrap');

InertiaProgress.init();

const theme = extendTheme({
  colors: {
    primary: {
      400: '#e7e2ff',
      500: '#551ec8',
      600: '#39149f',
    },
    customGray: {
      500: '#1a202c',
    },
  },
  components: {
    Tooltip: {
      sizes: {
        xs: {
          fontSize: 'xs',
        },
      },
    },
    Switch: {
      defaultProps: {
        colorScheme: 'customGray',
      },
    },
  },
});

const el = document.getElementById('app');

render(
  <ChakraProvider theme={theme}>
    <App
      initialPage={JSON.parse(el.dataset.page)}
      resolveComponent={(name) => import(`@/pages/${name}`).then((module) => module.default)}
    />
  </ChakraProvider>,
  el,
);
